import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "login-wrapper" }
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  id: "log_reg",
  class: "hidden-sm-and-down"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "login-title" }, "CO 3.0", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("登录")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 根据用户名，获取验证码 ")
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("重置")

  
const __default__ = {
  name: 'login'
}
import { reactive, ref, Ref, watch, onMounted } from 'vue'
import { ElForm, ElMessage, ElMessageBox } from 'element-plus'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import Api from '@/http/modules/index'
import Qs from "qs"
import WwLogin from '@/assets/ts/wwLogin.js'
import 'element-plus/theme-chalk/display.css'
type FormInstance = InstanceType<typeof ElForm>
interface User {
  username: string
  password: string
  code: string
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const {
  // 根据用户名，获取用户信息
  'GET/users/username': userInfoApi,
  // 根据手机号，发送验证码
  'GET/users/send_sms': sendPsdMessageApi,
  // 找回密码
  'PATCH/users/forget_pwd': forget_pwdApi,
  // 登录
  'POST/token': loninApi,
  // 校验是否需要发送手机验证码
  'GET/check_login': check_loginApi,
  // 扫码登录
  'GET/oauth2/webInfo': getQrcodeApi,
  // 获取用户信息
  'GET/token/info': tokenInfoApi,
  // 获取jwt token
  'GET/jwt/token': jwtTokenApi,
} = Api


const store = useStore()
const router = useRouter()
const route = useRoute()

// 扫码登录判断
let targetStr: string = '/'
watch(() => route.query, (newQuery, preQuery) => {
  console.log(newQuery);
  
  targetStr = '/'
  if(newQuery.redirect){
    targetStr = newQuery.redirect as string
  }

  if(newQuery.token){
    // 已经扫码登录
    let {username, userId, token, status} = newQuery
    // ResetRequired: 没有改过密码
    /* if(['NoLogin', 'Disabled'].includes(status as string)){
      store.commit('SET_TOKEN', '')
      ElMessageBox.alert('账号过期或不可登录', '提示', { confirmButtonText: '确定' })
      return
    } */
    // Enabled, ResetRequired 可以登陆
    store.commit('SET_INITIA_LOGIN', status === 'ResetRequired' ? true : false)

    store.commit('SET_USER_NAME', username)
    store.commit('SET_USER_ID', userId)
    store.commit('SET_TOKEN', token)
    router.push({path: targetStr, query: newQuery })
  }
  
}, {immediate: true})

let wwLoginObj: any
onMounted(() => {
  getQrcodeApi({url: targetStr}).then((rep: any) => {
    wwLoginObj = new WwLogin({
      "id": "log_reg", 
      "appid": rep.appid,
      "agentid": rep.agentId,
      "redirect_uri": rep.redirectUrl,
      "state": rep.state,
    })
  })
})

const user = reactive({
  username: "",
  password: "",
} as User)
const rules = reactive({
  username: [{ required: true, message: "请输入用户名", trigger: "change" }],
  password: [{ required: true, message: "请输入密码", trigger: "change" }],
})
const userForm = ref<FormInstance>()
const loginBtnFg = ref<boolean>(false)
const login = (formEl: FormInstance | undefined) => {
  if (!formEl || loginBtnFg.value) return
  // loginBtnFg.value = true
  formEl.validate((valid: boolean) => {
    if (!valid) return;

    // 第一步调用登录接口,判断用户名密码是否正确
    loginBtnFg.value = true
    loninApi(Qs.stringify(user) as any).then((resule: any) => {
      store.commit('SET_TOKEN', resule.token)
      // 获取用户信息
      return tokenInfoApi()
    }).then(({userId, status, userName}: any) => {
      loginBtnFg.value = false;
      // NoLogin, Disabled 不可登录
      /* if(['NoLogin', 'Disabled'].includes(status as string)){
        store.commit('SET_TOKEN', '')
        ElMessageBox.alert('账号过期或不可登录', '提示', { confirmButtonText: '确定' })
        return
      } */
      // Enabled, ResetRequired 可以登陆
      localStorage.setItem('loginStatus', status)
      store.commit('SET_INITIA_LOGIN', status === 'ResetRequired' ? true : false)
      store.commit('SET_USER_ID', userId)
      store.commit('SET_USER_NAME', user.username)
      if(targetStr&&targetStr.includes('credits.ccjk.com')){ //跳转到火花兑换页面需要添加token
        jwtTokenApi().then((res:any)=>{
          window.location.href=targetStr+`?token=${res.token}`
        })
        return
      }
      router.push(targetStr)
      ElMessage.success('登录成功')
    }).catch(error => {
      loginBtnFg.value = false
      user.code = ''
    })
  })
}

// ----------找回密码----------
const forgetFg = ref<boolean>(false)
const forget_userName = ref('')
const suffixPhone = ref('')
const countdown = ref<number>(0)
let countdownId: any

const countdownHandle = () => {
  // 倒计时处理
  // 如果刚发送过验证码，还在冷期却
  if(countdown.value > 0 ) return false;
  // 可以发送验证码，开始倒计时
  countdown.value = 60
  countdownId = setInterval(() => {
    countdown.value--
    if(countdown.value === 0) clearInterval(countdownId);
  }, 1000)

  return true
}

// 获取短信
const getPhoneMessage = async (username: string) => {
  // 根据用户名，获取手机号，基本信息等，
  suffixPhone.value = ''
  let { phoneNumber } = await userInfoApi({username})
  suffixPhone.value = phoneNumber.slice(-4)
  // 开始倒计时
  if(!countdownHandle()){
    return
  }

  await sendPsdMessageApi({phoneNumber})
  ElMessage.success('验证码已发送')
}

const userInfoHandle = async () => {
  if(forget_userName.value === ''){
    ElMessage.warning('请输入登录名')
    return
  }
  getPhoneMessage(forget_userName.value)
  /* // 根据用户名，获取手机号，基本信息等，
  suffixPhone.value = ''
  let { phoneNumber } = await userInfoApi({username: forget_userName.value})
  suffixPhone.value = phoneNumber.slice(-4)
  // 开始倒计时
  if(!countdownHandle()){
    return
  }

  await sendPsdMessageApi({phoneNumber})
  ElMessage.success('验证码已发送') */
}

// 登录时，获取验证码
const getLoginMessage = () => {
  if(user.username === ''){
    ElMessage.warning('请输入用户名再获取短信')
    return
  }
  getPhoneMessage(user.username)
}

const paswEle: any = ref<FormInstance>()
const forgetForm = reactive({
  password: '',
  confirmPwd: '',
  code: '',
})
const pasRules = reactive({
  
  password: [
    { required: true, message: '请输入密码', trigger: 'change' },
    { 
      validator: (rule: any, value: any, callback: any) => {
        if (value === '') {
          callback(new Error('请输入密码'))
        } else {
          if (forgetForm.password !== '') {
          if (!paswEle.value) return
            paswEle.value.validateField('password', () => null)
          }
          callback()
        }
      }, trigger: 'change'
    }
  ],
  confirmPwd: [
    { required: true, message: '请确认密码', trigger: 'change' },
    { 
      validator: (rule: any, value: any, callback: any) => {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== forgetForm.password) {
          callback(new Error("两次密码不一致"))
        } else {
          callback()
        }
      }, trigger: 'change'
    }
  ],
  code: [{ required: true, message: '请输入验证码', trigger: 'change' },],
})

const submitPassword = () => {
  // 
  paswEle.value.validate(async (valid: boolean) => {
    if (valid) {
      await forget_pwdApi({...forgetForm, username: forget_userName.value})
      // 修改成功后重置
      ElMessage.success('修改成功')
      paswEle.value.resetFields()
      clearInterval(countdownId);
      countdown.value = 0
      forgetFg.value = false

    } else {
      console.log('error submit!')
      return false
    }
}) 
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_unref(ElForm), {
        model: _unref(user),
        "status-icon": "",
        rules: _unref(rules),
        ref_key: "userForm",
        ref: userForm,
        class: "login-form"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createVNode(_component_el_form_item, { prop: "username" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "请输入用户名",
                type: "text",
                "prefix-icon": "User",
                modelValue: _unref(user).username,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(user).username) = $event)),
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { prop: "password" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "请输入密码",
                "show-password": "",
                type: "password",
                "prefix-icon": "Lock",
                modelValue: _unref(user).password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(user).password) = $event)),
                onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (login(userForm.value)), ["enter","native"]))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                loading: loginBtnFg.value,
                type: "primary",
                class: "btn-login",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (login(userForm.value))),
                size: "large"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          }),
          _createElementVNode("a", {
            class: "forgetPsd hidden-sm-and-down",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (forgetFg.value = true))
          }, "忘记密码")
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _createVNode(_component_el_dialog, {
      center: "",
      width: "33%",
      modelValue: forgetFg.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((forgetFg).value = $event)),
      onClose: _cache[12] || (_cache[12] = ($event: any) => (paswEle.value.resetFields())),
      title: "找回密码"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_timeline, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_timeline_item, {
              color: '#00ff00',
              timestamp: "请输入登录名",
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      class: "form-input",
                      placeholder: "请输入登录名",
                      modelValue: forget_userName.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((forget_userName).value = $event)),
                      clearable: ""
                    }, null, 8, ["modelValue"]),
                    _hoisted_6,
                    _createVNode(_component_el_button, {
                      onClick: userInfoHandle,
                      class: "mt-10 mb-10",
                      type: "primary",
                      disabled: countdown.value > 0
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7,
                        (countdown.value > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, " (" + _toDisplayString(countdown.value) + ")", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    (!suffixPhone.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_9, "验证码会发送至你在公司预留的的手机号上"))
                      : _createCommentVNode("", true),
                    (suffixPhone.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, " 验证码已发送至你的手机(尾号：" + _toDisplayString(suffixPhone.value) + ")", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_timeline_item, {
              timestamp: "重置密码",
              placement: "top",
              inline: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElForm), {
                      model: _unref(forgetForm),
                      rules: _unref(pasRules),
                      ref_key: "paswEle",
                      ref: paswEle,
                      "label-position": "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          prop: "password",
                          label: "新密码"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              class: "form-input",
                              autocomplete: "off",
                              placeholder: "新密码",
                              modelValue: _unref(forgetForm).password,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(forgetForm).password) = $event)),
                              type: "password",
                              clearable: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          prop: "confirmPwd",
                          label: "确认密码"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              class: "form-input",
                              autocomplete: "off",
                              placeholder: "确认密码",
                              modelValue: _unref(forgetForm).confirmPwd,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(forgetForm).confirmPwd) = $event)),
                              type: "password",
                              clearable: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          prop: "code",
                          label: "验证码"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              class: "form-input",
                              autocomplete: "off",
                              placeholder: "请输入短信验证码",
                              modelValue: _unref(forgetForm).code,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(forgetForm).code) = $event)),
                              clearable: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (submitPassword()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_11
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (paswEle.value.resetFields()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_12
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model", "rules"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})